import type {
  PermissionType,
  PermissionMetadata,
  PermissionResult
} from '../types'
import { BasePermissionStrategy } from './base.strategy'
import { Service } from '@/services/helpers/ServiceHelper'

export class ContactsStrategy extends BasePermissionStrategy {
  readonly type: PermissionType = 'contacts'

  readonly metadata: PermissionMetadata = {
    type: 'contacts',
    title: 'Contacts',
    description:
        'We use your contacts to allow you to send messages to your own contacts through the Emissary App. Please grant us permission to read your contacts.',
    deniedTitle: 'Contacts Access Disabled',
    deniedDescription:
        "Phone contacts won't be suggested inside the App. To enable, please go to your device settings."
  }

  isSupported (): boolean {
    return this.context.isMobile
  }

  async check (): Promise<PermissionResult> {
    if (!this.isSupported()) {
      return this.createResult('unsupported')
    }
    return await this.checkMobile()
  }

  async request (): Promise<PermissionResult> {
    if (!this.isSupported()) {
      return this.createResult('unsupported')
    }
    return await this.requestMobile()
  }

  // === MOBILE ===
  private async checkMobile (): Promise<PermissionResult> {
    try {
      const result =
          await Service.capacitor.permissionsCapacitor?.checkPermission(
            'contacts'
          )
      if (!result) {
        return this.createResult('unsupported')
      }
      return this.createResult(result.state)
    } catch {
      return this.createResult('unsupported')
    }
  }

  private async requestMobile (): Promise<PermissionResult> {
    try {
      const result =
          await Service.capacitor.permissionsCapacitor?.requestPermission(
            'contacts'
          )
      if (!result) {
        return this.createResult('unsupported')
      }
      return this.createResult(result.state)
    } catch {
      return this.createResult('denied')
    }
  }
}
